import React from 'react';
import ExperimentContext from './ExperimentContext';
import VisibilitySensor from 'react-visibility-sensor';

const style = {
  minHeight: '1px',
  marginTop: '-1px',
  display: 'block'
};

const isFunction = value => typeof value === 'function';

const Experiment = ({ name, children, minTopValue = 10, report, earlyReport }) => (
  <ExperimentContext.Consumer>
    {(experiments) => {
      const experiment = experiments.getExperiment(name);
      const value = experiments.getExperimentValue(name);
      const renderedChildren = isFunction(children) ? children(value, experiment) : children;
      const isReportable = isFunction(report) ? report(value) : report;
      const isEarlyReport = isFunction(earlyReport) ? earlyReport(value) : earlyReport;
      const isInactive = value === -1 || value === null;

      if (!isInactive && isEarlyReport) {
        experiments.exposeExperiment(name);
      }
      if (!isReportable || isEarlyReport || isInactive) {
        return renderedChildren;
      }

      return (
        <VisibilitySensor
          partialVisibility
          minTopValue={minTopValue}
          delayedCall
          onChange={experiments.visibilityHandler(name)}
        >
          { renderedChildren && <div style={{ minHeight: '1px' }}>{renderedChildren}</div> || (<span style={style} />)}
        </VisibilitySensor>
      );
    }}
  </ExperimentContext.Consumer>
);

export default Experiment;
